

export default class MultiSceneCommand {

    constructor(options) {
        this._options = options || {};
    }

    getName() {
        return this._name;
    }

    execute(multiSceneViewer, params) {
        // nop;
    }
}
